import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MfaService } from '../../../shared/services/mfa.service';
import { AccountInformationInterface } from '../../models/account-information.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { EStepActions, SetStep } from '../../../shared/store/actions/step.actions';

@Component({
  selector: 'app-account-confirmation',
  templateUrl: './account-confirmation.component.html',
  styleUrls: ['./account-confirmation.component.css'],
  standalone: false
})
export class AccountConfirmationComponent implements OnInit {

  @Input()
  accountInformation?: AccountInformationInterface;

  @Output()
  accountConfirmation = new EventEmitter<any>();

  form: FormGroup;
  formSubmitted: boolean;
  errors: any = {
    code: {
      required: `Le code est obligatoire.`,
    }
  };
  constructor(
      private formBuilder: FormBuilder,
      private mfaService: MfaService,
      private actions$: Actions,
      private store: Store<any>
  ) { }

  ngOnInit() {
    this.formSubmitted = false;
    this.actions$.pipe(ofType(EStepActions.SetStep)).subscribe((result: SetStep) => {
      if (result.step) {
        this.mfaService.sendCode(this.accountInformation.email, 'first_connexion').subscribe(
            response => {
              this.initForm();
            }, error => {
              const alertMessage = { message: ConstsHelper.ERROR_OCCURRED_MESSAGE, code: 400 } as AlertMessageInterface;
              this.store.dispatch(new GetAlertMessage(alertMessage));
            }
        );
      }
    });
  }

  initForm() {
    this.form = this.formBuilder.group({});
    this.form = new FormGroup({
      code: new FormControl('', [Validators.required]),
    });
  }

  submit() {
    this.formSubmitted = true;
    if (this.form.valid) {
      const accountConfirmation =  {
        code: this.form.get('code').value
      };
      this.accountConfirmation.emit(accountConfirmation);
    }
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
